import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
  import SwitchComponent from "@/components/ui/SwitchComponent.vue";
  import { headerTabs } from "@/constants/navigationTabs";
  import { SwitchItemHeader } from "@/types/SwitchItemHeader";
  import router from "@/router";
  import { useRoute } from "vue-router";
  import { RouteLandingNames } from "@/enums/RouteLandingNames";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LandingMobileHeader',
  emits: ["close", "signIn"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const route = useRoute();

  const emits = __emit;
  const onSingIn = () => emits("signIn");

  const onChangeHeaderTab = (value: SwitchItemHeader) =>
    router.push(value.path);

  const activeHeaderTab = ref<SwitchItemHeader | null>(null);

  const visibleHeaderTabs = computed(() =>
    headerTabs.filter((tab) => !tab.hidden)
  );

  watch(
    router.currentRoute,
    (value) => {
      if (value.name === RouteLandingNames.LANDING_BUILDERS) {
        activeHeaderTab.value = headerTabs[1];
      } else if (value.name === RouteLandingNames.LANDING) {
        activeHeaderTab.value = headerTabs[0];
      } else {
        activeHeaderTab.value = headerTabs[2];
      }
    },
    { immediate: true }
  );

const __returned__ = { route, emits, onSingIn, onChangeHeaderTab, activeHeaderTab, visibleHeaderTabs, computed, ref, watch, SwitchComponent, get headerTabs() { return headerTabs }, get SwitchItemHeader() { return SwitchItemHeader }, get router() { return router }, get useRoute() { return useRoute }, get RouteLandingNames() { return RouteLandingNames } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})